/* eslint-disable no-console */
import {
    SAVE_POSTS,
    SAVE_TAGS,
    SAVE_CATEGORY,
} from './_types';

const formatPost = (post) => {
    const location = window.location.origin;

    post.excerpt.rendered = post.excerpt.rendered.replace('[&hellip;]', '&hellip;');
    post.excerpt.renderedShort = `${post.excerpt.rendered.substr(0, 150)} &hellip;`;

    const regExp = /(http:\/\/)?(https:\/\/)?(www\.)?taskflex\.dk![/wp-]/g;

    post.content.rendered = post.content.rendered.replace(regExp, `${location}/blog`);

    return post;
};

export default {
    [SAVE_POSTS](state, newPosts) {
        const { posts } = state;
        const formattedPosts = newPosts.map(formatPost);

        // Append and sort posts
        posts.push(...formattedPosts);
        posts.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

        // Filter for duplicates
        state.posts = posts.filter((post, index, arr) => arr
            .map(mapObj => mapObj.id)
            .indexOf(post.id) === index);
    },

    [SAVE_TAGS](state, newTags) {
        const { tags } = state;

        tags.push(...newTags);
        tags.sort(a => a.count);

        // Filter for duplicates
        state.tags = tags.filter((tag, index, arr) => arr
            .map(mapObj => mapObj.id)
            .indexOf(tag.id) === index);
    },

    [SAVE_CATEGORY](state, newCategory) {
        state.categories.push(newCategory);
    },
};



// WEBPACK FOOTER //
// ./src/taskflex/blog/store/_mutators.js